import { DoctorDtoResponse } from 'apps/woundscantwait-com/src/packages/doctors/doctors';

const nearDoctorsResponseToTableDataHelper = (doctors: DoctorDtoResponse[]) => {
  return doctors.map((doctor) => ({
    name: `${doctor.firstname} ${doctor.lastname}`,
    city: doctor.city,
    state: doctor.state,
    zip: doctor.zipcode,
    phone: doctor.phone,
    institution: doctor.institution,
    specialty: doctor.primaryspecialty,
  }));
};

export { nearDoctorsResponseToTableDataHelper };
